import 'primereact/resources/themes/md-light-deeppurple/theme.css';
//import '../styles/main.scss';

import React from 'react';
import { createRoot } from 'react-dom/client';
import Routes from './components/Routes';

const root = createRoot(document.getElementById('calendar-root') as HTMLElement);

root.render(
    <Routes />
);